<template>
	<drawer
			:title="titleDrawer"
			@updateClose="onClose"
			@updateSave="onSave"
			width="600"
			is-height
	>
		<div class="drawerWrap">
			<div class="infoUserVacation">
				<div class="infoTitle">Summary for this day</div>
				<item-info-row
						icon-id="calendarAlt"
						text="Date:"
						:value="`${name} - ${date}`"
				></item-info-row>
				<item-info-row
						icon-id="TimeFast"
						text="Worked period:"
						:value="`${check_in} - ${check_out}`"
				></item-info-row>
				<item-info-row
						icon-id="statistics-chart-graph	"
						text="Schedule period:"
						:value="`${schedule_in} - ${schedule_out}`"
				></item-info-row>
				<item-info-row
						icon-id="TimeCheck"
						text="Worked time:"
						:value="total_time"
				></item-info-row>

				<div v-if="duty || remote || sick || vacation || !!holiday" class="infoTitle">
					<div class="text">Event day</div>
					<svg-sprite icon-id="warning" width="20" height="20"></svg-sprite>
				</div>
				<div v-if="duty" class="event">
					<svg-sprite color="#ffad46" icon-id="Binoculars" width="20" height="20"></svg-sprite>
					<div class="text">Duty</div>
				</div>
				<div v-if="remote" class="event">
					<svg-sprite color="#ffad46" icon-id="HomeWifi" width="20" height="20"></svg-sprite>
					<div class="text">Remote</div>
				</div>
				<div v-if="sick" class="event">
					<svg-sprite color="#ffad46" icon-id="Medicine" width="20" height="20"></svg-sprite>
					<div class="text">Sickleave</div>
				</div>
				<div v-if="vacation" class="event">
					<svg-sprite color="#ffad46" icon-id="Umbrella" width="20" height="20"></svg-sprite>
					<div class="text">Vacation</div>
				</div>
				<div v-if="!!holiday" class="event">
					<svg-sprite color="#ffad46" icon-id="icon-bbq" width="20" height="20"></svg-sprite>
					<div class="text">{{ holiday }}</div>
				</div>
			</div>

			<div  class="cardWrap">
				<no-info v-if="notes.length <= 0" :text="`For ${name} ${date}, there are no comments yet`"/>

				<line-comment
						v-else
						v-for="(item, index) in notes"
						:key="index"
						:item="item">
				</line-comment>
			</div>

			<field
					:class-error="getError('note')"
					margin="0 0 10px 0"
					label="Note"
					placeholder="Enter note"
					:setInputValue="note"
					@updateInput="onInput($event, 'note')"
					is-textarea
					is-required
			></field>
		</div>

	</drawer>
</template>

<script>
import Drawer from "@/shared/Drawer/Drawer";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import ItemInfoRow from "@/shared/ItemInfoRow/ItemInfoRow.vue";
import LineComment from "@/shared/AccountDayChat/LineComment.vue";
import NoInfo from "@/shared/NoInfo/NoInfo.vue";

export default {
	name: "AccountDayChat",
	mixins: [ validationMixin ],
	components: { NoInfo, LineComment, ItemInfoRow, Drawer },
	props: {
		activeItem: Object,
		employeeId: Number,
	},
	validations: {
		note: { required },
		// date: { required },
	},

	data() {
		return {
			titleDrawer: `Day chat 📅 ✨`,
			note: null,

			check_in: null,
			check_out: null,
			date: null,
			duty: null,
			holiday: null,
			isDisabled: null,
			name: null,
			notes: '',
			remote: null,
			schedule_in: null,
			schedule_out: null,
			sick: null,
			total_time: null,
			vacation: null,
		};
	},
	methods: {
		// onDate(value) {
		// 	this.date = value;
		// },
		getError(key) {
			return this.$v[key] && this.$v[key].$error;
		},
		onSave() {
			this.$v.$touch();
			if (!this.$v.$error) {
				// 'employee_id'   => 'required|integer',
				// 'date'          => 'required|date',
				// 'note'          => 'required',
				// 'file'          => 'array',
				// 'file.value'    => 'nullable',
				// 'file.name'     => 'nullable',
				const employee_id = this.employeeId;
				const { note, date } = this.$data;
				this.$emit('updateSave', { note, employee_id, date });
			} else {
				this.$store.dispatch('setAlert', { type: "error", message: `📝 Please fill in the <b>Note</b> field.` });
			}
		},
		onClose() {
			this.$emit('updateClose');
		},
		onInput({ value }, key) {
			this[key] = value;
		},
		onAutocomplete({ value }, key) {
			this[key] = value.id;
		},
		onCheckbox({ value }, key) {
			this[key] = value;
		},
	},
	mounted() {
		if (this.activeItem) {
			const {
				check_in,
				check_out,
				date,
				duty,
				holiday,
				isDisabled,
				name,
				notes,
				remote,
				schedule_in,
				schedule_out,
				sick,
				total_time,
				vacation,
			} = this.activeItem;

			this.date = date;
			this.duty = duty;
			this.holiday = holiday;
			this.isDisabled = isDisabled;
			this.name = name;
			this.notes = notes ? notes : '';
			this.remote = remote;
			this.schedule_in = schedule_in;
			this.schedule_out = schedule_out;
			this.sick = sick;
			this.vacation = vacation;

			this.check_in = check_in.length > 0 ? check_in.slice(0, -3) : '-'; // Удаляем последние 3 символа (Секунді)
			this.check_out = check_out.length > 0 ? check_out.slice(0, -3) : '-';
			this.total_time = total_time === '00:00:00' ? '-' : total_time.slice(0, -3);
		}
	}
};

</script>

<style scoped lang="scss">
.drawerWrap {
	display: flex;
	flex-direction: column;
	gap: 10px;
	flex: 2 0;
	height: 80px;

	.cardWrap {
		flex: 2 0;
		display: flex;
		flex-direction: column;
		gap: 10px;
		height: 100%;
		overflow: auto;
	}
	.event {
		padding: 3px 10px;
		display: flex;
		align-items: center;
		gap: 10px;
	}
}

.infoUserVacation {
	display: flex;
	flex-direction: column;
	gap: 8px;
	margin-bottom: 14px;
	.infoTitle {
		font-weight: bold;
		color: #a3a3a3;
		display: flex;
		align-items: center;
		gap: 10px;
	}
}

</style>
